import { render, staticRenderFns } from "./guide-switch-from-official.vue?vue&type=template&id=a3ca2b78"
import script from "./guide-switch-from-official.vue?vue&type=script&lang=js"
export * from "./guide-switch-from-official.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports